export const OPEN_SUCCESS_PURCHASE_POPUP = 'OPEN_SUCCESS_PURCHASE_POPUP';
export const HIDE_SUCCESS_PURCHASE_POPUP = 'HIDE_SUCCESS_PURCHASE_POPUP';
export const OPEN_TERMS_AND_CONDITION_POPUP = 'OPEN_TERMS_AND_CONDITION_POPUP';
export const HIDE_TERMS_AND_CONDITION_POPUP = 'HIDE_TERMS_AND_CONDITION_POPUP';
export const OPEN_CONNECTION_WALLET_POPUP = 'OPEN_CONNECTION_WALLET_POPUP ';
export const HIDE_CONNECTION_WALLET_POPUP = 'HIDE_CONNECTION_WALLET_POPUP';
